import flaguzb from "../assets/images/flags/uz.svg";
import flagrussia from "../assets/images/flags/russia.svg";
import flagus from "../assets/images/flags/us.svg";

export const languages = {
    oz: {
        label: "O'zbekcha",
        flag: flaguzb,
    },
    ru: {
        label: "Rусский",
        flag: flagrussia,
    },
    uz: {
        label: "Ўзбекча",
        flag: flaguzb,
    },
    en: {
        label: "English",
        flag: flagus,
    },
    // gr: {
    //   label: "Deutsche",
    //   flag: flaggermany,
    // },
}